import backendUrl from "./backendUrl";

export const categoryApi = {
  createCategory: {
    url: `${backendUrl}/api/create-category`,
    method: "post",
  },
  getAllCategories: {
    url: `${backendUrl}/api/get-all-categories`,
    method: "get",
  },
  updateCategory: {
    url: `${backendUrl}/api/update-category`,
    method: "put",
  },
  deleteCategory: {
    url: `${backendUrl}/api/delete-category`,
    method: "delete",
  },
};
